module.exports = __webpack_public_path__ + "static/media/serv-7.26da5581.jpg";